import { render } from "./App.vue?vue&type=template&id=525b8298"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=525b8298&lang=css"

import exportComponent from "/Users/mattia/Desktop/Projects/elbi-website-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__